import React from 'react';
import PropTypes from 'prop-types';

const VenueListingLink = ({ name, id }) => (
  <a href={`#/venues/${id}`} className="venue">
    <div className="name">{`${name} - ${id}`}</div>
  </a>
);

VenueListingLink.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};

export default VenueListingLink;
